import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";
import { normalizeDCCostMainRows } from "./dcCostMainApi";

const normalizeColorPayload = (payload) => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.detailRows)) {
    return payload.detailRows;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.rows)) {
    return payload.rows;
  }

  if (Array.isArray(payload?.content)) {
    return payload.content;
  }

  if (Array.isArray(payload?.data?.detailRows)) {
    return payload.data.detailRows;
  }

  if (Array.isArray(payload?.data?.rows)) {
    return payload.data.rows;
  }

  if (Array.isArray(payload?.data?.content)) {
    return payload.data.content;
  }

  return [payload];
};

export const getDCCostColorRows = async (batchId, batchType) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return [];
  }

  const normalizedBatchId = batchId ?? "";
  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.dcCostColor}/${normalizedBatchId}`;
  const response = await getAPI(apiUrl, tokenInfo);

  if (response.ok) {
    const payload = await response.json().catch(() => []);
    return normalizeDCCostMainRows(normalizeColorPayload(payload)).map((row) => ({
      ...row,
      color: row.color || row.dcEstimationStatus || row.status,
      status: row.dcEstimationStatus || row.status,
    }));
  }

  const errorData = await response.json().catch(() => ({}));
  AlertManager.error(errorData?.message || "Failed to load DC color plan data.", { contactSupport: false });
  return [];
};

export default getDCCostColorRows;
